"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
export default function Concierge() {
  const {
    ref: brandRef,
    isVisible: brandVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: nameImageRef,
    isVisible: nameImageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="14580" id="refined-beauty-delivered" className="bg-background text-foreground py-16 md:py-24 overflow-hidden light">
      <link rel="preload" as="image" href="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728549/img/Idealimage%20vector%20Name%20Web.svg" imageSrcSet="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728549/img/Idealimage%20vector%20Name%20Web.svg 320w, https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728549/img/Idealimage%20vector%20Name%20Web.svg 380w" imageSizes="(max-width: 640px) 320px, 380px" fetchPriority="high" />
      <div className="mx-auto w-full max-w-[1240px] px-6 md:px-8">
        <div ref={nameImageRef} className="mb-8 md:mb-12 flex justify-center" style={{
        opacity: nameImageVisible ? 1 : 0,
        transform: nameImageVisible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 600ms cubic-bezier(0.22, 1, 0.36, 1), transform 600ms cubic-bezier(0.22, 1, 0.36, 1)",
        willChange: nameImageVisible ? "opacity, transform" : "auto"
      }}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728549/img/Idealimage%20vector%20Name%20Web.svg" srcSet="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728549/img/Idealimage%20vector%20Name%20Web.svg 320w, https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728549/img/Idealimage%20vector%20Name%20Web.svg 380w" sizes="(max-width: 640px) 320px, 380px" width="380" height="100" alt="Professional concierge service visual" className="max-w-[320px] md:max-w-[380px] h-auto" loading="eager" fetchPriority="high" decoding="sync" />
        </div>

        <div ref={brandRef} className="flex justify-center mb-8 md:mb-10" style={{
        opacity: brandVisible ? 1 : 0,
        transform: brandVisible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 600ms cubic-bezier(0.22, 1, 0.36, 1), transform 600ms cubic-bezier(0.22, 1, 0.36, 1)",
        willChange: brandVisible ? "opacity, transform" : "auto"
      }}>
          <Link to="/">
            
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-center">
          <div ref={contentRef} className="order-2 lg:order-1 lg:col-span-7">
            <h1 className="font-default text-foreground" style={{
            fontSize: "clamp(2.5rem, 5.4vw, 4.5rem)",
            fontWeight: 400,
            letterSpacing: "-0.02em",
            lineHeight: 1.08,
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 600ms cubic-bezier(0.22, 1, 0.36, 1), transform 600ms cubic-bezier(0.22, 1, 0.36, 1)",
            willChange: contentVisible ? "opacity, transform" : "auto"
          }}>Refined <span className="relative inline-block italic font-serif"><span>facial balancing</span><span aria-hidden="true" className="absolute left-0 right-0 block bg-[var(--ring)]" style={{
                bottom: '-0.05em',
                height: '1.5px',
                transformOrigin: 'left center',
                transform: 'scaleX(1)',
                transition: 'transform 700ms ease-out 400ms'
              }}></span></span> in San Antonio & Garden Ridge.</h1>

            <p className="font-default mt-7 text-muted-foreground max-w-[480px]" style={{
            fontSize: "clamp(1.125rem, 1.3vw, 1.25rem)",
            fontWeight: 400,
            lineHeight: 1.65,
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 600ms cubic-bezier(0.22, 1, 0.36, 1), transform 600ms cubic-bezier(0.22, 1, 0.36, 1)",
            transitionDelay: "120ms",
            willChange: contentVisible ? "opacity, transform" : "auto"
          }}>Coming Soon. Pre-Book Now. Experience private, concierge aesthetic care by Dr. Amber Ojeda, DNP, APRN, FNP‑C. Natural results, effortless symmetry, and professional expertise in your own space.</p>

            <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-7" style={{
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 600ms cubic-bezier(0.22, 1, 0.36, 1), transform 600ms cubic-bezier(0.22, 1, 0.36, 1)",
            transitionDelay: "240ms",
            willChange: contentVisible ? "opacity, transform" : "auto"
          }}>
              <Button asChild size="lg" className="bg-[var(--ring)] hover:bg-[var(--accent-foreground)] text-primary-foreground rounded-lg px-7 h-[52px] text-base font-medium transition-colors duration-[400ms] ease-out">
                <Link to="/ExperiencePage">Explore our services</Link>
              </Button>

              <Link to="https://my.portraitcare.com/booking/?business_id=jr3uOp" newTab className="group inline-flex items-center gap-2 text-foreground font-default text-base font-medium">
                <span>
                  Or book a{" "}
                  <span className="underline decoration-[var(--ring)] underline-offset-4 decoration-[1.5px]">
                    consultation
                  </span>
                </span>
                <ArrowRight className="size-4 transition-transform duration-[350ms] ease-out group-hover:translate-x-1" strokeWidth={1.75} />
              </Link>
            </div>

            <div className="mt-10" style={{
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 600ms cubic-bezier(0.22, 1, 0.36, 1), transform 600ms cubic-bezier(0.22, 1, 0.36, 1)",
            transitionDelay: "360ms",
            willChange: contentVisible ? "opacity, transform" : "auto"
          }}>
              <Badge variant="secondary" className="bg-secondary text-secondary-foreground rounded-lg px-3.5 py-1.5 text-[0.8rem] font-medium border-0 inline-flex items-center gap-2">
                <span className="size-1.5 rounded-lg bg-[var(--ring)]" />
                Accepting new concierge clients
              </Badge>
            </div>
          </div>

          <div ref={imageRef} className="order-1 lg:order-2 lg:col-span-5" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 600ms cubic-bezier(0.22, 1, 0.36, 1), transform 600ms cubic-bezier(0.22, 1, 0.36, 1)",
          transitionDelay: "180ms",
          willChange: imageVisible ? "opacity, transform" : "auto"
        }}>
            <div className="group relative overflow-hidden rounded-3xl shadow-lg aspect-[4/5] lg:aspect-[4/5]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728549/img/refined-facial-balancing-botox-san-antonio.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728549/img/refined-facial-balancing-botox-san-antonio.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728549/img/refined-facial-balancing-botox-san-antonio.webp-wvc-sizes" alt="Sophisticated, minimalist aesthetic treatment space with soft lighting and rose gold accents" fetchPriority="high" decoding="async" className="w-full h-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-[1.03]" />
              <WvcLogo className="absolute bottom-8 right-8 w-1/6 max-w-[70px] opacity-20 pointer-events-none z-10 transition-opacity duration-500 group-hover:opacity-30" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}